import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  MobileNavigationBar,
  MobileNavItem,
} from "./styledComponents/NavigationBarComponents";
import {
  LJAlogo,
  LeaderboardIcon,
  SettingsIcon,
  ShoppingCartIcon,
  GamesIcon,
} from "../../constants/icons/navbarIcons";
import { COLORS } from "../../constants/colors/colors";
import { GlassmorphismContainer } from "../GlassmorphismContainer/GlassmorphismContainer";
import { useAppSelector } from "../../store/hooks";
import { CONTRAST_ENUM } from "../../pages/SettingsPage/constants/constants";

const getIconColor = (
  locationPath: string,
  path: string,
  contrast: CONTRAST_ENUM,
): string => {
  if (locationPath === path) return COLORS.AQUA;
  if (contrast === CONTRAST_ENUM.WHITE) return COLORS.BOUNDLESS_BLUE;
  return COLORS.WHITE;
};

const Navigation = () => {
  const location = useLocation();
  const { t } = useTranslation("common");

  const contrast = useAppSelector((state) => state.userInfo.contrast);

  const navItems = [
    {
      path: "/shop",
      label: t("nav.shop"),
      icon: (
        <ShoppingCartIcon
          fill={getIconColor(location.pathname, "/shop", contrast)}
          width="1.875rem"
          height="1.875rem"
          aria-hidden
        />
      ),
    },
    {
      path: "/leaderboard",
      label: t("nav.leaderboard"),
      icon: (
        <LeaderboardIcon
          fill={getIconColor(location.pathname, "/leaderboard", contrast)}
          width="1.875rem"
          height="1.875rem"
          aria-hidden
        />
      ),
    },
    {
      path: "/home",
      label: t("nav.home"),
      icon: (
        <LJAlogo
          width="1.8rem"
          height="1.875rem"
          primaryColor={
            location.pathname === "/home" || contrast === CONTRAST_ENUM.WHITE
              ? "#385F73"
              : "#FFF"
          }
          secondaryColor={
            location.pathname === "/home" || contrast === CONTRAST_ENUM.WHITE
              ? "#489EAD"
              : "#FFF"
          }
          aria-hidden
        />
      ),
    },
    {
      path: "/minigames",
      label: t("nav.minigames"),
      icon: (
        <GamesIcon
          fill={getIconColor(location.pathname, "/minigames", contrast)}
          width="1.875rem"
          height="1.875rem"
          aria-hidden
        />
      ),
    },
    {
      path: "/settings",
      label: t("nav.settings"),
      icon: (
        <SettingsIcon
          fill={getIconColor(location.pathname, "/settings", contrast)}
          width="1.875rem"
          height="1.875rem"
          aria-hidden
        />
      ),
    },
  ];

  return (
    <MobileNavigationBar>
      <GlassmorphismContainer
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        width="100%"
        hasBorder
        borderRadius="32rem"
        padding="0.5rem"
        contrast={contrast}
      >
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <MobileNavItem
              key={item.path}
              to={item.path}
              isActive={isActive}
              aria-label={item.label}
              aria-current={isActive ? "page" : undefined}
            >
              {item.icon}
            </MobileNavItem>
          );
        })}
      </GlassmorphismContainer>
    </MobileNavigationBar>
  );
};

export default Navigation;
